/* ============================================================================
FILE: po-katupirsia9-axe-dore-texts-fr-en-es-20260326.js
MODE: manual protected trilingual injection + audio layer
API:  window.PoK9AxeDoreTextsFR_EN_ES_20260326
ROOT: .po-axis-section[data-po-axis='axe_dore']
ROLE:
  - Bloque les traductions extérieures sur le bloc.
  - Active uniquement la traduction interne via boutons FR / EN / ES.
  - Verrouille le vocabulaire canonique et ses caractères spéciaux.
  - CTA fin de page via slot : cta_translate.
  - Ajoute une lecture audio générale et locale par bloc sans remplacer le système existant.
============================================================================ */
(function(){
  "use strict";

  if (window.__PO_K9_AXE_DORE_TEXTS_20260326__) return;
  window.__PO_K9_AXE_DORE_TEXTS_20260326__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var ROOT_SELECTOR = ".po-axis-section[data-po-axis='axe_dore']";

  var CONCEPT_URL  = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/axe_dore_conceptuel.png?v=1773255953";
  var FUNCTION_URL = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/axe_dore_fonctionnel.png?v=1773255954";

  function clampStr(v){ return (v == null) ? "" : String(v); }

  function normLang(raw){
    var s = clampStr(raw).toUpperCase().trim();
    if (s === "EN" || s === "ES") return s;
    return "FR";
  }

  function readStoredLang(){
    try{
      var v = localStorage.getItem(STORAGE_KEY);
      return v ? normLang(v) : "FR";
    }catch(e){
      return "FR";
    }
  }

  function storeLang(lang3){
    try{ localStorage.setItem(STORAGE_KEY, normLang(lang3)); }catch(e){}
  }

  function nt(txt){
    return '<span class="notranslate" translate="no">' + clampStr(txt) + '</span>';
  }

  var COPY = {
    FR: {
      title: "Axe doré",
      kicker: "Extrait du <em>Katûpirsia&nbsp;9 - Âṣẹxel’Or</em><br />(Grammaire dorée, Katûvýs, alignement et élévation de la conscience)",
      h_def: "Définition opérative",
      chips: ["Idéogramme conceptuel", "Idéogramme fonctionnel"],
      chip_urls: [CONCEPT_URL, FUNCTION_URL],
      def_short: "Dans la grammaire dorée de K9, l’Axe doré qualifie une tenue, un support et un alignement ; dans la Katûvýs, il désigne l’alignement du Sujet Pluriel avec la matrice cosmique.",
      def_long:
        "<p>Dans la grammaire dorée rattachée à " + nt("Âṣẹxel’Or") + " et au " + nt("Souffle d’Or") + ", la forme canonique " + nt("X doré(e)") + " sert à qualifier une tenue, une matière, un axe ou une disposition. " + nt("Axe doré") + " relève de cette famille des qualités, supports et alignements.</p>" +
        "<p>Dans le manuscrit de " + nt("Katûpirsia 9") + ", " + nt("Axe doré") + " apparaît explicitement dans la " + nt("Katûvýs") + " et reçoit ce sens : alignement du " + nt("Sujet Pluriel") + " avec la matrice cosmique.</p>" +
        "<p>La synthèse finale associe " + nt("Amplitude dorée") + " et " + nt("Axe doré") + " à l’élévation de la conscience. Cette proximité précise le rôle de l’" + nt("Axe doré") + " : il ne nomme pas un simple décor lumineux, mais une tenue de conscience, un axe de justesse et d’orientation dans le champ doré.</p>" +
        "<p>Aucun nombre-guide spécifique pour " + nt("Axe doré") + " n’est attesté dans les documents fournis ; la page conserve donc les idéogrammes canoniquement disponibles et un terme associé directement relié.</p>",
      h_features: "Dynamiques attestées",
      h_questions: "Repères d’usage",
      h_family: "Liens systémiques",
      h_wordbuild: "Construction du terme",
      hint_fold: "déplier",
      example_title: "Ex.",
      example: "Dans une phase de réaccord, l’Axe doré se manifeste lorsqu’une disposition, un geste ou un champ retrouve une tenue capable d’aligner le Sujet Pluriel avec la matrice cosmique.",
      features: [
        "Famille canonique : X doré(e) = qualité, support, alignement.",
        "Fonction attestée : alignement du Sujet Pluriel avec la matrice cosmique.",
        "Rattachement : grammaire dorée de K9, sous l’horizon de Âṣẹxel’Or et du Souffle d’Or.",
        "Relation interne : avec l’Amplitude dorée, l’Axe doré participe à l’élévation de la conscience."
      ],
      questions: [
        "Quel axe, quelle disposition ou quelle tenue demandent ici un réalignement ?",
        "Le Sujet Pluriel est-il accordé à la matrice cosmique, ou seulement orienté en surface ?",
        "L’enjeu relève-t-il d’un support, d’un alignement ou d’un régime du Souffle ?",
        "Quel lien vivant se dessine ici avec l’Amplitude dorée et l’élévation de la conscience ?"
      ],
      family_1: "<p><strong>Grammaire dorée :</strong> " + nt("Axe doré") + " relève de la forme canonique " + nt("X doré(e)") + ", réservée aux qualités, supports et alignements. Il se classe du côté des tenues et dispositions, et non des opérateurs de type " + nt("X d’Or") + " ni des régimes de type " + nt("Or de X") + ".</p>",
      family_2: "<p><strong>Liens internes :</strong> dans la " + nt("Katûvýs") + ", l’" + nt("Axe doré") + " nomme l’alignement du " + nt("Sujet Pluriel") + " avec la matrice cosmique ; dans la synthèse de K9, il forme avec l’" + nt("Amplitude dorée") + " un couple d’élévation de la conscience, au sein de la continuité " + nt("Souffle d’Or") + " → " + nt("Katûvýs d’Or") + " → " + nt("Âṣẹxel’Or") + ".</p>",
      word_blocks: [
        { head: "1) Axe", text: "Support d’orientation, de tenue et d’alignement." },
        { head: "2) Doré", text: "Dans K9, il ne décrit pas une simple couleur : il qualifie une qualité, un support ou une disposition dans la grammaire dorée." },
        { head: "3) Axe doré", text: "Formule canonique de soutien et d’alignement : dans la Katûvýs, le Sujet Pluriel s’accorde à la matrice cosmique." }
      ],
      word_notes: [
        "Statut lexical : gold_quality / Supports – Alignements.",
        "Aucun nombre-guide propre à Axe doré n’est attesté dans les documents fournis."
      ],
      cta_translate: "Proposer une traduction du concept",
      langbar_aria: "Choix de langue",
      audio_general: "Écouter le texte",
      audio_block: "Écouter ce bloc",
      audio_stop: "Arrêter la lecture"
    },
    EN: {
      title: "Axe doré",
      kicker: "Excerpt from <em>Katûpirsia&nbsp;9 - Âṣẹxel’Or</em><br />(Golden grammar, Katûvýs, alignment and elevation of consciousness)",
      h_def: "Operative definition",
      chips: ["Conceptual ideogram", "Functional ideogram"],
      chip_urls: [CONCEPT_URL, FUNCTION_URL],
      def_short: "In K9’s golden grammar, " + "Axe doré" + " qualifies a hold, a support and an alignment; in the Katûvýs, it designates the alignment of the Sujet Pluriel with the cosmic matrix.",
      def_long:
        "<p>In the golden grammar linked to " + nt("Âṣẹxel’Or") + " and " + nt("Souffle d’Or") + ", the canonical form " + nt("X doré(e)") + " is used to qualify a hold, a matter, an axis or a disposition. " + nt("Axe doré") + " belongs to this family of qualities, supports and alignments.</p>" +
        "<p>In the manuscript of " + nt("Katûpirsia 9") + ", " + nt("Axe doré") + " appears explicitly in the " + nt("Katûvýs") + " and receives this meaning: alignment of the " + nt("Sujet Pluriel") + " with the cosmic matrix.</p>" +
        "<p>The final synthesis associates " + nt("Amplitude dorée") + " and " + nt("Axe doré") + " with the elevation of consciousness. This proximity clarifies the role of " + nt("Axe doré") + ": it does not name a simple luminous decor, but a hold of consciousness, an axis of rightness and orientation within the golden field.</p>" +
        "<p>No specific guide-number for " + nt("Axe doré") + " is attested in the provided documents; the page therefore keeps the canonically available ideograms and a directly related associated term.</p>",
      h_features: "Attested dynamics",
      h_questions: "Usage markers",
      h_family: "Systemic links",
      h_wordbuild: "Term construction",
      hint_fold: "expand",
      example_title: "Ex.",
      example: "In a phase of re-attunement, Axe doré manifests when a disposition, a gesture or a field regains a hold capable of aligning the Sujet Pluriel with the cosmic matrix.",
      features: [
        "Canonical family: X doré(e) = quality, support, alignment.",
        "Attested function: alignment of the Sujet Pluriel with the cosmic matrix.",
        "Attachment: K9’s golden grammar, under the horizon of Âṣẹxel’Or and Souffle d’Or.",
        "Internal relation: together with Amplitude dorée, Axe doré participates in the elevation of consciousness."
      ],
      questions: [
        "Which axis, disposition or hold calls here for a realignment?",
        "Is the Sujet Pluriel attuned to the cosmic matrix, or only oriented on the surface?",
        "Does the issue concern a support, an alignment or a regime of Souffle d’Or?",
        "What living link appears here with Amplitude dorée and the elevation of consciousness?"
      ],
      family_1: "<p><strong>Golden grammar:</strong> " + nt("Axe doré") + " belongs to the canonical form " + nt("X doré(e)") + ", reserved for qualities, supports and alignments. It is classified on the side of holds and dispositions, not operators of the type " + nt("X d’Or") + " nor regimes of the type " + nt("Or de X") + ".</p>",
      family_2: "<p><strong>Internal links:</strong> in the " + nt("Katûvýs") + ", " + nt("Axe doré") + " names the alignment of the " + nt("Sujet Pluriel") + " with the cosmic matrix; in K9’s synthesis, it forms with " + nt("Amplitude dorée") + " a pair tied to the elevation of consciousness, within the continuity " + nt("Souffle d’Or") + " → " + nt("Katûvýs d’Or") + " → " + nt("Âṣẹxel’Or") + ".</p>",
      word_blocks: [
        { head: "1) Axis", text: "Support of orientation, hold and alignment." },
        { head: "2) Doré", text: "In K9, it does not describe a simple color: it qualifies a quality, a support or a disposition within the golden grammar." },
        { head: "3) Axe doré", text: "Canonical formula of support and alignment: in the Katûvýs, the Sujet Pluriel attunes to the cosmic matrix." }
      ],
      word_notes: [
        "Lexical status: gold_quality / Supports – Alignments.",
        "No guide-number specific to Axe doré is attested in the provided documents."
      ],
      cta_translate: "Suggest a translation of the concept",
      langbar_aria: "Language selection",
      audio_general: "Listen to the text",
      audio_block: "Listen to this block",
      audio_stop: "Stop playback"
    },
    ES: {
      title: "Axe doré",
      kicker: "Extracto de <em>Katûpirsia&nbsp;9 - Âṣẹxel’Or</em><br />(Gramática dorada, Katûvýs, alineación y elevación de la conciencia)",
      h_def: "Definición operativa",
      chips: ["Ideograma conceptual", "Ideograma funcional"],
      chip_urls: [CONCEPT_URL, FUNCTION_URL],
      def_short: "En la gramática dorada de K9, " + "Axe doré" + " califica una sostén, un soporte y una alineación; en la Katûvýs, designa la alineación del Sujet Pluriel con la matriz cósmica.",
      def_long:
        "<p>En la gramática dorada ligada a " + nt("Âṣẹxel’Or") + " y a " + nt("Souffle d’Or") + ", la forma canónica " + nt("X doré(e)") + " sirve para calificar una tenue, una materia, un eje o una disposición. " + nt("Axe doré") + " pertenece a esta familia de cualidades, soportes y alineaciones.</p>" +
        "<p>En el manuscrito de " + nt("Katûpirsia 9") + ", " + nt("Axe doré") + " aparece explícitamente en la " + nt("Katûvýs") + " y recibe este sentido: alineación del " + nt("Sujet Pluriel") + " con la matriz cósmica.</p>" +
        "<p>La síntesis final asocia " + nt("Amplitude dorée") + " y " + nt("Axe doré") + " con la elevación de la conciencia. Esta proximidad precisa el papel de " + nt("Axe doré") + ": no nombra un simple decorado luminoso, sino una tenue de conciencia, un eje de justeza y de orientación dentro del campo dorado.</p>" +
        "<p>Ningún número-guía específico para " + nt("Axe doré") + " está atestiguado en los documentos proporcionados; por tanto, la página conserva los ideogramas canónicamente disponibles y un término asociado directamente relacionado.</p>",
      h_features: "Dinámicas atestiguadas",
      h_questions: "Puntos de uso",
      h_family: "Vínculos sistémicos",
      h_wordbuild: "Construcción del término",
      hint_fold: "desplegar",
      example_title: "Ej.",
      example: "En una fase de reajuste, Axe doré se manifiesta cuando una disposición, un gesto o un campo recupera una tenue capaz de alinear el Sujet Pluriel con la matriz cósmica.",
      features: [
        "Familia canónica: X doré(e) = cualidad, soporte, alineación.",
        "Función atestiguada: alineación del Sujet Pluriel con la matriz cósmica.",
        "Vinculación: gramática dorada de K9, bajo el horizonte de Âṣẹxel’Or y Souffle d’Or.",
        "Relación interna: con Amplitude dorée, Axe doré participa en la elevación de la conciencia."
      ],
      questions: [
        "¿Qué eje, qué disposición o qué tenue piden aquí una realineación?",
        "¿El Sujet Pluriel está acordado con la matriz cósmica, o solo orientado en la superficie?",
        "¿El enjeu pertenece a un soporte, a una alineación o a un régimen de Souffle d’Or?",
        "¿Qué vínculo vivo se dibuja aquí con Amplitude dorée y la elevación de la conciencia?"
      ],
      family_1: "<p><strong>Gramática dorada:</strong> " + nt("Axe doré") + " pertenece a la forma canónica " + nt("X doré(e)") + ", reservada a cualidades, soportes y alineaciones. Se clasifica del lado de las tenues y disposiciones, y no de los operadores de tipo " + nt("X d’Or") + " ni de los regímenes de tipo " + nt("Or de X") + ".</p>",
      family_2: "<p><strong>Vínculos internos:</strong> en la " + nt("Katûvýs") + ", " + nt("Axe doré") + " nombra la alineación del " + nt("Sujet Pluriel") + " con la matriz cósmica; en la síntesis de K9, forma con " + nt("Amplitude dorée") + " una pareja vinculada a la elevación de la conciencia, dentro de la continuidad " + nt("Souffle d’Or") + " → " + nt("Katûvýs d’Or") + " → " + nt("Âṣẹxel’Or") + ".</p>",
      word_blocks: [
        { head: "1) Eje", text: "Soporte de orientación, tenue y alineación." },
        { head: "2) Doré", text: "En K9, no describe un simple color: califica una cualidad, un soporte o una disposición dentro de la gramática dorada." },
        { head: "3) Axe doré", text: "Fórmula canónica de soporte y alineación: en la Katûvýs, el Sujet Pluriel se acuerda con la matriz cósmica." }
      ],
      word_notes: [
        "Estatus léxico: gold_quality / Supports – Alignements.",
        "Ningún número-guía propio de Axe doré está atestiguado en los documentos proporcionados."
      ],
      cta_translate: "Proponer una traducción del concepto",
      langbar_aria: "Selección de idioma",
      audio_general: "Escuchar el texto",
      audio_block: "Escuchar este bloque",
      audio_stop: "Detener la lectura"
    }
  };

  function setSlotText(root, slot, txt){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    el.textContent = clampStr(txt);
  }

  function setSlotHTML(root, slot, html){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    el.innerHTML = clampStr(html);
  }

  function setSlotImgSrc(root, slot, src, alt){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    if (src) el.setAttribute("src", clampStr(src));
    if (alt) el.setAttribute("alt", clampStr(alt));
  }

  function renderListInto(root, slot, items){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    el.innerHTML = "";
    for (var i = 0; i < (items || []).length; i++){
      var li = document.createElement("li");
      li.textContent = clampStr(items[i]);
      el.appendChild(li);
    }
  }

  function renderWordBlocks(root, slot, blocks){
    var host = root.querySelector("[data-po-slot='" + slot + "']");
    if (!host) return;
    host.innerHTML = "";
    for (var i = 0; i < (blocks || []).length; i++){
      var b = blocks[i] || {};
      var wrap = document.createElement("div");
      wrap.className = "po-axis-wb";
      var h = document.createElement("div");
      h.className = "po-axis-wb__h";
      h.textContent = clampStr(b.head || "");
      var t = document.createElement("div");
      t.className = "po-axis-wb__t";
      t.textContent = clampStr(b.text || "");
      wrap.appendChild(h);
      wrap.appendChild(t);
      host.appendChild(wrap);
    }
  }

  function updateLangButtons(root, lang3){
    var buttons = root.querySelectorAll(".po-langbtn[data-po-lang]");
    for (var i = 0; i < buttons.length; i++){
      var btn = buttons[i];
      var active = normLang(btn.getAttribute("data-po-lang")) === lang3;
      btn.classList.toggle("is-active", active);
      btn.setAttribute("aria-pressed", active ? "true" : "false");
    }
    var bar = root.querySelector(".po-langbar");
    var C = COPY[lang3] || COPY.FR;
    if (bar) bar.setAttribute("aria-label", clampStr(C.langbar_aria || ""));
  }

  function notifyLocaleChanged(){
    try{
      window.dispatchEvent(new CustomEvent("po:locale-changed", { detail: { lang: readStoredLang() } }));
    }catch(e){
      try{
        var ev = document.createEvent("CustomEvent");
        ev.initCustomEvent("po:locale-changed", true, true, { lang: readStoredLang() });
        window.dispatchEvent(ev);
      }catch(_e){}
    }
  }

  /* ============================================================================
     AUDIO LOCAL PAR BLOC + TEXTE GÉNÉRAL
  ============================================================================ */

  var PO_AUDIO_SYNTH = (typeof window !== "undefined" && window.speechSynthesis) ? window.speechSynthesis : null;

  var PO_AUDIO_STATE = {
    root: null,
    units: [],
    unitPos: -1,
    chunks: [],
    activeKey: "",
    isStopping: false
  };

  function audioUI(lang3){
    var C = COPY[normLang(lang3)] || COPY.FR;
    return {
      general: C.audio_general,
      block: C.audio_block,
      stop: C.audio_stop
    };
  }

  function getSpeechLang(lang3){
    var L = normLang(lang3);
    if (L === "EN") return "en-US";
    if (L === "ES") return "es-ES";
    return "fr-FR";
  }

  function ensureAudioStyles(){
    if (document.getElementById("po-k9-axe-dore-audio-styles")) return;
    var style = document.createElement("style");
    style.id = "po-k9-axe-dore-audio-styles";
    style.textContent =
      ".po-axis-audio-wrap{display:flex;justify-content:flex-start;align-items:center;margin:10px 0 12px;}" +
      ".po-axis-audio-btn{" +
        "appearance:none;border:1px solid rgba(0,0,0,.12);background:rgba(255,255,255,.66);" +
        "border-radius:999px;padding:7px 12px;font:inherit;font-size:12px;font-weight:700;" +
        "letter-spacing:.02em;cursor:pointer;transition:all .18s ease;line-height:1.2;}" +
      ".po-axis-audio-btn:hover{background:rgba(0,0,0,.04);}" +
      ".po-axis-audio-btn.is-playing{background:rgba(184,134,11,.08);border-color:rgba(184,134,11,.45);}" +
      ".po-axis-audio-btn[data-po-audio-kind='block']{margin-left:auto;flex:0 0 auto;}" +
      ".po-lex-summary{position:relative;}" +
      ".po-lex-summary__title{display:inline-flex;align-items:center;gap:10px;min-width:0;}" +
      "@media (max-width:760px){.po-axis-audio-btn{font-size:11px;padding:7px 10px;}}";
    document.head.appendChild(style);
  }

  function stopAudio(){
    PO_AUDIO_STATE.isStopping = true;
    try{
      if (PO_AUDIO_SYNTH) PO_AUDIO_SYNTH.cancel();
    }catch(e){}
    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.activeKey = "";
    clearPlayingButtons();
    setTimeout(function(){ PO_AUDIO_STATE.isStopping = false; }, 0);
  }

  function clearPlayingButtons(){
    var all = document.querySelectorAll(".po-axis-audio-btn.is-playing");
    for (var i = 0; i < all.length; i++){
      all[i].classList.remove("is-playing");
    }
  }

  function setPlayingButtons(root, key){
    clearPlayingButtons();
    if (!root || !key) return;
    var btn = root.querySelector(".po-axis-audio-btn[data-po-audio-key='" + key + "']");
    if (btn) btn.classList.add("is-playing");
  }

  function cleanText(text){
    return clampStr(text)
      .replace(/\u00A0/g, " ")
      .replace(/\s+/g, " ")
      .replace(/\s+([,.;:!?])/g, "$1")
      .trim();
  }

  function getNodeText(el){
    if (!el) return "";
    return cleanText(el.textContent || el.innerText || "");
  }

  function collectGeneralText(root){
    var parts = [];
    var slots = ["title", "kicker", "h_def", "def_short", "def_long"];
    for (var i = 0; i < slots.length; i++){
      var el = root.querySelector("[data-po-slot='" + slots[i] + "']");
      if (el) parts.push(getNodeText(el));
    }
    return cleanText(parts.join(" "));
  }

  function collectBlockText(details){
    if (!details) return "";
    var parts = [];
    var summaryTitle = details.querySelector(".po-lex-summary__title");
    if (summaryTitle) parts.push(getNodeText(summaryTitle));

    var clone = details.cloneNode(true);
    var summary = clone.querySelector("summary");
    if (summary && summary.parentNode) summary.parentNode.removeChild(summary);
    var buttons = clone.querySelectorAll(".po-axis-audio-btn");
    for (var i = 0; i < buttons.length; i++){
      if (buttons[i] && buttons[i].parentNode) buttons[i].parentNode.removeChild(buttons[i]);
    }
    parts.push(getNodeText(clone));
    return cleanText(parts.join(" "));
  }

  function splitSpeechText(text){
    var source = cleanText(text);
    if (!source) return [];
    var maxLen = 210;
    var out = [];
    var current = "";
    var segments = source.split(/(?<=[\.\!\?\:\;])\s+/);

    function pushCurrent(){
      current = cleanText(current);
      if (current) out.push(current);
      current = "";
    }

    for (var i = 0; i < segments.length; i++){
      var seg = cleanText(segments[i]);
      if (!seg) continue;
      if (!current){
        current = seg;
      } else if ((current + " " + seg).length <= maxLen){
        current += " " + seg;
      } else {
        pushCurrent();
        if (seg.length <= maxLen){
          current = seg;
        } else {
          var words = seg.split(/\s+/);
          var buffer = "";
          for (var j = 0; j < words.length; j++){
            var w = words[j];
            if (!buffer){
              buffer = w;
            } else if ((buffer + " " + w).length <= maxLen){
              buffer += " " + w;
            } else {
              out.push(cleanText(buffer));
              buffer = w;
            }
          }
          current = buffer;
        }
      }
    }
    pushCurrent();
    return out;
  }

  function createUtterance(text, lang3, onEnd){
    var u = new SpeechSynthesisUtterance(text);
    u.lang = getSpeechLang(lang3);
    u.rate = 1;
    u.pitch = 1;
    u.volume = 1;
    u.onend = function(){
      if (typeof onEnd === "function") onEnd();
    };
    u.onerror = function(){
      if (typeof onEnd === "function") onEnd();
    };
    return u;
  }

  function speakChunks(chunks, lang3, done){
    if (!PO_AUDIO_SYNTH || !chunks.length){
      if (typeof done === "function") done();
      return;
    }
    var idx = 0;
    function next(){
      if (PO_AUDIO_STATE.isStopping) return;
      if (idx >= chunks.length){
        if (typeof done === "function") done();
        return;
      }
      var utter = createUtterance(chunks[idx], lang3, function(){
        idx += 1;
        next();
      });
      try{
        PO_AUDIO_SYNTH.speak(utter);
      }catch(e){
        idx += 1;
        next();
      }
    }
    next();
  }

  function buildUnits(root){
    var units = [];
    var generalText = collectGeneralText(root);
    if (generalText){
      units.push({
        key: "general",
        type: "general",
        node: root,
        getText: function(){ return collectGeneralText(root); }
      });
    }
    var blocks = root.querySelectorAll(".po-lex-details");
    for (var i = 0; i < blocks.length; i++){
      (function(index, details){
        units.push({
          key: "block-" + index,
          type: "block",
          node: details,
          getText: function(){ return collectBlockText(details); }
        });
      })(i, blocks[i]);
    }
    return units;
  }

  function playUnitSequence(root, startIndex){
    if (!root) return;
    if (!PO_AUDIO_SYNTH){
      return;
    }
    stopAudio();
    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.units = buildUnits(root);
    PO_AUDIO_STATE.unitPos = startIndex;
    if (startIndex < 0 || startIndex >= PO_AUDIO_STATE.units.length) return;

    function playCurrent(){
      if (PO_AUDIO_STATE.isStopping) return;
      var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos];
      if (!unit){
        stopAudio();
        return;
      }

      if (unit.type === "block" && unit.node && !unit.node.open){
        unit.node.open = true;
      }

      PO_AUDIO_STATE.activeKey = unit.key;
      setPlayingButtons(root, unit.key);

      var txt = cleanText(unit.getText());
      var chunks = splitSpeechText(txt);
      var lang3 = readStoredLang();

      if (!chunks.length){
        PO_AUDIO_STATE.unitPos += 1;
        if (PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length){
          stopAudio();
        } else {
          playCurrent();
        }
        return;
      }

      speakChunks(chunks, lang3, function(){
        if (PO_AUDIO_STATE.isStopping) return;
        PO_AUDIO_STATE.unitPos += 1;
        if (PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length){
          stopAudio();
        } else {
          playCurrent();
        }
      });
    }

    playCurrent();
  }

  function createAudioButton(kind, key){
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "po-axis-audio-btn";
    btn.setAttribute("data-po-audio-kind", kind);
    btn.setAttribute("data-po-audio-key", key);
    return btn;
  }

  function updateAudioButtonLabels(root, lang3){
    var ui = audioUI(lang3);
    var all = root.querySelectorAll(".po-axis-audio-btn");
    for (var i = 0; i < all.length; i++){
      var btn = all[i];
      var kind = btn.getAttribute("data-po-audio-kind");
      var key = btn.getAttribute("data-po-audio-key") || "";
      var isPlaying = btn.classList.contains("is-playing");
      btn.textContent = isPlaying ? ui.audio_stop || ui.stop : (kind === "general" ? ui.general : ui.block);
      btn.setAttribute("aria-label", btn.textContent);
      if (key === "general") btn.setAttribute("title", ui.general);
    }
  }

  function ensureAudioButtons(root){
    if (!root) return;
    ensureAudioStyles();

    var panel = root.querySelector(".po-lex-panel");
    if (!panel) return;

    var generalWrap = root.querySelector(".po-axis-audio-wrap[data-po-audio-role='general']");
    if (!generalWrap){
      generalWrap = document.createElement("div");
      generalWrap.className = "po-axis-audio-wrap";
      generalWrap.setAttribute("data-po-audio-role", "general");
      generalWrap.appendChild(createAudioButton("general", "general"));

      var meta = panel.querySelector(".po-axis-meta");
      var defShort = panel.querySelector("[data-po-slot='def_short']");
      var firstDetails = panel.querySelector(".po-lex-details");

      if (meta && meta.parentNode === panel && meta.nextSibling){
        panel.insertBefore(generalWrap, meta.nextSibling);
      } else if (defShort && defShort.parentNode === panel){
        panel.insertBefore(generalWrap, defShort);
      } else if (firstDetails && firstDetails.parentNode === panel){
        panel.insertBefore(generalWrap, firstDetails);
      } else {
        panel.appendChild(generalWrap);
      }
    }

    var details = root.querySelectorAll(".po-lex-details");
    for (var i = 0; i < details.length; i++){
      var summary = details[i].querySelector(".po-lex-summary");
      if (!summary) continue;
      var btn = summary.querySelector(".po-axis-audio-btn[data-po-audio-kind='block']");
      if (!btn){
        btn = createAudioButton("block", "block-" + i);
        summary.appendChild(btn);
      } else {
        btn.setAttribute("data-po-audio-key", "block-" + i);
      }
    }
  }

  function bindAudioHandlers(root){
    if (!root || root.__poAudioBound) return;
    root.__poAudioBound = true;

    root.addEventListener("click", function(ev){
      var btn = ev.target && ev.target.closest ? ev.target.closest(".po-axis-audio-btn") : null;
      if (!btn || !root.contains(btn)) return;

      ev.preventDefault();
      ev.stopPropagation();

      var key = btn.getAttribute("data-po-audio-key") || "";
      var isPlaying = btn.classList.contains("is-playing");

      if (isPlaying){
        stopAudio();
        updateAudioButtonLabels(root, readStoredLang());
        return;
      }

      var units = buildUnits(root);
      var startIndex = 0;
      for (var i = 0; i < units.length; i++){
        if (units[i].key === key){
          startIndex = i;
          break;
        }
      }
      playUnitSequence(root, startIndex);
      updateAudioButtonLabels(root, readStoredLang());
    }, true);
  }

  function initAudioEverywhere(lang3){
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    for (var i = 0; i < roots.length; i++){
      ensureAudioButtons(roots[i]);
      bindAudioHandlers(roots[i]);
      updateAudioButtonLabels(roots[i], lang3);
    }
  }

  function render(root, lang3){
    var C = COPY[normLang(lang3)] || COPY.FR;

    root.classList.add("notranslate");
    root.setAttribute("translate", "no");

    var scope = root.querySelector(".po-lex-scope[data-po-lex-scope]");
    if (scope){
      scope.classList.add("notranslate");
      scope.setAttribute("translate", "no");
    }

    setSlotText(root, "title", C.title);
    setSlotHTML(root, "kicker", C.kicker);
    setSlotImgSrc(root, "title_img", C.chip_urls[0], C.title);

    setSlotText(root, "h_def", C.h_def);
    setSlotText(root, "chip_1", C.chips[0]);
    setSlotText(root, "chip_2", C.chips[1]);
    setSlotImgSrc(root, "chip_1_img", C.chip_urls[0], C.chips[0]);
    setSlotImgSrc(root, "chip_2_img", C.chip_urls[1], C.chips[1]);

    setSlotText(root, "def_short", C.def_short);
    setSlotHTML(root, "def_long", C.def_long);

    setSlotText(root, "h_features", C.h_features);
    setSlotText(root, "h_questions", C.h_questions);
    setSlotText(root, "h_family", C.h_family);
    setSlotText(root, "h_wordbuild", C.h_wordbuild);
    setSlotText(root, "hint_fold", C.hint_fold);
    setSlotText(root, "hint_fold2", C.hint_fold);
    setSlotText(root, "hint_fold3", C.hint_fold);
    setSlotText(root, "hint_fold4", C.hint_fold);

    renderListInto(root, "features", C.features);
    renderListInto(root, "questions", C.questions);
    setSlotHTML(root, "example_box", "<div><strong>" + C.example_title + "</strong> " + C.example + "</div>");
    setSlotHTML(root, "family_1", C.family_1);
    setSlotHTML(root, "family_2", C.family_2);
    renderWordBlocks(root, "wordbuild_blocks", C.word_blocks);
    renderListInto(root, "wordbuild_notes", C.word_notes);
    setSlotText(root, "cta_translate", C.cta_translate);

    updateLangButtons(root, normLang(lang3));
  }

  function applyLangEverywhere(lang3){
    lang3 = normLang(lang3);
    storeLang(lang3);
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    for (var i = 0; i < roots.length; i++) render(roots[i], lang3);
    initAudioEverywhere(lang3);
    notifyLocaleChanged();
  }

  function wireLangButtons(root){
    var bar = root.querySelector(".po-langbar");
    if (!bar || bar.__poLangBound) return;
    bar.__poLangBound = true;

    bar.addEventListener("click", function(ev){
      var btn = ev.target && ev.target.closest ? ev.target.closest(".po-langbtn[data-po-lang]") : null;
      if (!btn) return;
      ev.preventDefault();
      applyLangEverywhere(btn.getAttribute("data-po-lang") || "FR");
    });
  }

  function init(){
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    for (var i = 0; i < roots.length; i++) wireLangButtons(roots[i]);
    applyLangEverywhere(readStoredLang());
  }

  if (document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.PoK9AxeDoreTextsFR_EN_ES_20260326 = {
    init: init,
    setLang: applyLangEverywhere,
    getLang: readStoredLang,
    normLang: normLang,
    stopAudio: stopAudio
  };
})();
